import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, opacity = 1, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd" opacity={opacity} strokeLinecap="round">
      <path d="M7 8h10M7 12h10M7 16h5" />
    </g>
  </svg>
);
